import { formatCalendarDate } from '../../../Utils/calendarDate';
import { IonButton, IonButtons, IonCol, IonContent, IonFooter, IonGrid, IonHeader, IonIcon, IonItem, IonLabel, IonRow, IonSpinner, IonTitle, IonToast, IonToolbar } from '@ionic/react';
import { arrowBackOutline, calendarOutline, cardOutline, carOutline, cashOutline, copyOutline, locationOutline, ticketOutline } from 'ionicons/icons';
import React, { useContext, useState } from 'react';
import { MessageContext } from '../../../contexts/MessageContext';
import './RevisarPedido.css';

type Props = {
  valorTotal: string;
  enderecoEntrega: string;
  complementoEntrega: string;
  formaPagamento: string;
  tempoEntrega: string;
  taxaEntrega: string;
  isRetirada: boolean;
  desconto: string;
  empresaEndereco: string;
  tipoAgendamento: string;
  dataAgendamento: string;
  horaAgendamento: string;
  submitting?: 'pedido' | 'pix' | 'acompanhamento' | null;
  errorMessage?: string;
  closeAction: () => void | Promise<void>;
  closeActionSimple: () => void;
}

const RevisarPedido: React.FC<Props> = (props: Props) => {

  const { dadosEmpresa } = useContext(MessageContext);
  const [showToast, setShowToast] = useState(false);

  const formaPagamentoEmpresa = dadosEmpresa?.formaPagamento?.find((fp: any) =>
    fp?.nome === props.formaPagamento || fp?.tipo === props.formaPagamento
  );
  const chavePix: string | undefined = formaPagamentoEmpresa?.tipo === "Pix" ? formaPagamentoEmpresa?.chavePix : "";

  const formatarValor = (valor: string) => {
    return `R$ ${valor}`;
  };

  const formatarData = formatCalendarDate;

  // Função para formatar a hora
  function formatarHora(isoTime: string): string {
    if (!isoTime) return "";
    // Extrair a parte da hora do formato ISO (2025-12-01T18:10)
    const timePart = isoTime.includes('T') ? isoTime.split('T')[1] : isoTime;
    const [hora, minuto] = timePart.split(':');
    return `${hora}:${minuto}`;
  }

  return (
    <>
      <IonHeader className="ion-no-border">
        <IonToolbar className="pedido-fluxo-modal-toolbar">
          <IonButtons slot="start" className="pedido-fluxo-back-buttons">
            <IonButton disabled={props.submitting ? true : undefined} className="pedido-fluxo-back-button" aria-label="Voltar" fill="clear" onClick={() => props.closeActionSimple()}>
              <IonIcon icon={arrowBackOutline} />
            </IonButton>
          </IonButtons>
          <IonTitle className="ion-text-wrap"><span className="modal-title-text">Revise o seu pedido</span></IonTitle>

        </IonToolbar>
      </IonHeader>

      <IonContent className="revisar-pedido-content" aria-busy={!!props.submitting}>

        {/* Informações de Data do Pedido */}
        <div hidden={!dadosEmpresa.agendamento}>
          <IonItem lines="none">
            <IonIcon slot="start" icon={calendarOutline} />
            <IonLabel className="ion-text-wrap">
              <div>
                {props.tipoAgendamento}
              </div>
              <div hidden={props.tipoAgendamento !== "AGENDADO"}>
                {formatarData(props.dataAgendamento) + " às " + formatarHora(props.horaAgendamento)}
              </div>
            </IonLabel>
          </IonItem>
        </div>

        {/* Informações de Entrega */}
        <div>
          <IonItem lines="none">
            <IonIcon slot="start" icon={carOutline} />
            <IonLabel className="ion-text-wrap">
              <div>
                {props.isRetirada ? 'Retirada' : 'Entrega'}
              </div>
              <div hidden={props.tipoAgendamento == "AGENDADO"}>
                {props.isRetirada ? `${props.tempoEntrega} minutos` : `${props.tempoEntrega} minutos / R$ ${props.taxaEntrega}`}
              </div>
            </IonLabel>
          </IonItem>
        </div>

        {/* Informações de Endereço */}
        <div>
          <IonItem lines="none">
            <IonIcon slot="start" icon={locationOutline} />
            <IonLabel className="ion-text-wrap">
              <div>
                {props.isRetirada ? 'Endereço do estabelecimento' : 'Endereço de entrega'}
              </div>
              <div>
                {props.isRetirada ? (
                  props.empresaEndereco
                ) : (
                  <>
                    {props.enderecoEntrega}
                    {props.complementoEntrega && (
                      <> / {props.complementoEntrega}</>
                    )}
                  </>
                )}
              </div>

            </IonLabel>
          </IonItem>
        </div>

        {/* Informações de Cupom */}
        <div hidden={!props.desconto}>
          <IonItem lines="none">
            <IonIcon slot="start" icon={ticketOutline} />
            <IonLabel className="ion-text-wrap">
              <div>
                Desconto
              </div>
              <div>
                {formatarValor(props.desconto)}
              </div>

            </IonLabel>
          </IonItem>
        </div>

        {/* Informações de Pagamento */}
        <div>
          <IonItem lines="none">
            <IonIcon slot="start" icon={cardOutline} />
            <IonLabel className="ion-text-wrap">
              <div>
                {props.formaPagamento}
              </div>
              <div>
                {chavePix && (
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <div style={{ fontWeight: 700, flex: 1, whiteSpace: 'normal', overflowWrap: 'break-word', wordBreak: 'break-all' }}>
                      Chave PIX: {chavePix}
                    </div>
                    <IonIcon
                      icon={copyOutline}
                      style={{ fontSize: '20px', cursor: 'pointer' }}
                      onClick={async () => {
                        try {
                          if (navigator.clipboard && navigator.clipboard.writeText) {
                            await navigator.clipboard.writeText(chavePix);
                          } else {
                            const el = document.createElement('textarea');
                            el.value = chavePix;
                            document.body.appendChild(el);
                            el.select();
                            document.execCommand('copy');
                            document.body.removeChild(el);
                          }
                          setShowToast(true);
                        } catch (e) {
                          setShowToast(true);
                        }
                      }}
                    />
                  </div>
                )}
              </div>


            </IonLabel>

          </IonItem>
        </div>


        <div>
          <IonItem lines="none">
            <IonIcon slot="start" icon={cashOutline} />
            <IonLabel className="ion-text-wrap">
              <div>
                Total do pedido
              </div>
              <div>
                {formatarValor(props.valorTotal)}
              </div>
            </IonLabel>

          </IonItem>
        </div>

      </IonContent>

      <IonFooter className="revisar-pedido-footer">
        {props.errorMessage && <div className="revisar-pedido-error" role="alert">{props.errorMessage}</div>}
        {props.submitting && <p className="revisar-pedido-progress" role="status">
          {props.submitting === 'acompanhamento' ? 'Pedido enviado! Abrindo o acompanhamento…'
            : props.submitting === 'pix' ? 'Preparando seu Pix. Aguarde para realizar o pagamento.'
            : 'Estamos enviando seu pedido. Aguarde a confirmação.'}
        </p>}
        <IonToolbar>
          <IonGrid>
            <IonRow>
              <IonCol>
                <IonButton
                  style={{ height: "46px", fontSize: "18px" }}
                  disabled={props.submitting ? true : undefined}
                  onClick={() => { if (!props.submitting) void props.closeAction(); }}
                  expand="block"
                  type="submit"
                >
                  {props.submitting && <IonSpinner name="crescent" aria-hidden="true" />}
                  {props.submitting === 'pix' ? 'Gerando Pix…' : props.submitting === 'acompanhamento' ? 'Abrindo pedido…' : props.submitting ? 'Enviando pedido…' : 'Fazer pedido'}
                </IonButton>

                <IonButton
                  style={{ height: "46px", fontSize: "18px" }}
                  disabled={props.submitting ? true : undefined}
                  onClick={() => props.closeActionSimple()}
                  expand="block"
                  fill="clear"
                >
                  Alterar pedido
                </IonButton>
              </IonCol>
            </IonRow>
          </IonGrid>
        </IonToolbar>
      </IonFooter>
      {/* Toast de cópia */}
      <IonToast
        isOpen={showToast}
        message="Chave PIX copiada!"
        duration={1500}
        onDidDismiss={() => setShowToast(false)}
      />
    </>
  );
};

export default RevisarPedido;
